export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4629.2df80cce.jpg";